import {InjectionToken} from "@angular/core";

export var ApiConfigService = new InjectionToken<ApiServicesConfig>("ApiConfig");

export interface ApiServicesConfig {
  production: boolean;
  isLocalhost: boolean;
  apiUrl: string;
  routes: string[];
}
